import BaseService from './BaseService';
import axios from 'axios';
import enitities from 'src/config/entities'

class SegmentService extends BaseService {

  constructor () {
    super({entity: enitities.SEGMENT})
  }

  /**
   * Retrieves list of segment groups with segments for a given set of job boards
   * @param {object} data
   * @return {Promise<any>}
   */
  async getJobBoardSegments(data) {
    try {
      let res = await this._instance.post(`/job-boards`, data);
      return res;
    } catch (e) {
      this._handleError({ translationKey: 'generic.create.error', error: e});
      throw e;
    }
  }

  async getSegmentGroups() {
    try {
      return await axios.get(`/segments-groups`);
    } catch (e) {
      this._handleError({translationKey: 'generic.get.error', error: e});
      throw e;
    }
  }
}

export default new SegmentService()
